export default function (context) {
  if (process.server) {
   const host = context.req.headers.host
   const path = context.route.path
   const redirect = context.redirect
   const env = process.env.NODE_ENV

   if ((env === 'production') && (host !== 'atlas-offshore-world.org') && (host.indexOf('staging') === -1)) {
     let targetUrl = 'https://atlas-offshore-world.org'
     targetUrl += '/' + path
     return redirect(301, targetUrl)
   }
 }
}


// WEBPACK FOOTER //
// ./middleware/redirectDomain.js